/** All route path constants used throughout the application */
export const ROUTES = {
  /** Public routes */
  LOGIN: '/login',

  /** Main authenticated routes */
  DASHBOARD: '/',
  JOBS: '/jobs',
  JOB_DETAIL: '/jobs/:jobId',
  JOB_NEW: '/jobs/new',

  /** Inspection routes */
  INSPECTION_NEW: '/jobs/:jobId/inspections/new',
  INSPECTION_DETAIL: '/jobs/:jobId/inspections/:inspectionId',

  /** Test panel routes */
  TEST_PANEL_NEW: '/jobs/:jobId/inspections/:inspectionId/test-panels/new',
  TEST_PANEL_DETAIL: '/jobs/:jobId/inspections/:inspectionId/test-panels/:panelId',

  /** Report routes */
  REPORTS: '/reports',
  REPORT_DETAIL: '/jobs/:jobId/reports/:reportId',

  /** Analyzer */
  ANALYZER: '/analyzer',

  /** Profile / Settings */
  PROFILE: '/profile',

  /** Admin routes */
  ADMIN: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_TEAMS: '/admin/teams',
  ADMIN_TEMPLATES: '/admin/templates',

  /** Platform (super-admin) routes */
  PLATFORM: '/platform',
} as const;

/** Helper to build dynamic routes with parameters */
export function buildRoute(
  route: string,
  params: Record<string, string>,
): string {
  let result = route;
  for (const [key, value] of Object.entries(params)) {
    result = result.replace(`:${key}`, encodeURIComponent(value));
  }
  return result;
}
